import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "@env/environment";
import { HttpUtilService } from "./http-util.service";
declare var require: any;
@Injectable({
  providedIn: "root",
})
export class LtiService {
  constructor(private httpService: HttpUtilService) {}
  /** A list of rules used to conver launch URLs*/
  conversionRules = [
    {
      description:
        "Convert canvas specific launch urls for Kaltur to the generic version",
      match: /kaltura\.com/i,
      target: /\/canvas\//gi,
      replace: "/generic/",
    },
  ];
  /**
   * Initiate a lauch request
   * @param tool Tool data to launch
   * @param item Data item to use as launch source
   * @param course Course
   * @param lms The lms settings to use for the launch
   * @param type The type of launch
   * @param accepts The return types accepted from the external tool
   */
  initLaunch(tool, item, course, lms, type, accepts): Observable<any> {
    let url =
      "/launch?tool=" +
      tool.id +
      "&item=" +
      item.id +
      "&lms=" +
      lms +
      "&course=" +
      course.id;
    if (type) {
      url += "&messagetype=" + type;
    }
    if (accepts) {
      url += "&accepts=" + accepts;
    }
    console.log(tool, "test");
    return this.httpService.request(
      "GET",
      environment.apiRoot + url,
      null,
      null,
      true
    );
  }
  /**
   * Launch from a LTI link
   * @param launchURL Lint to launch
   * @param course Course the launch is originating from
   * @param lms LEM setting to use for the launch
   */
  linkLaunch(launchURL, course, lms): Observable<any> {
    const url =
      "/launch?launchURL=" + launchURL + "&course=" + course.id + "&lms=" + lms;
    return this.httpService.request(
      "GET",
      environment.apiRoot + url,
      null,
      null,
      true
    );
  }
  /** Get a list of LTIs for the current instance */
  getToolList(): Observable<any> {
    return this.httpService.request(
      "GET",
      environment.apiRoot +
        "/lti?output=dataonly&key_values=id,launch_url,title,location&mode=list",
      null,
      null,
      true
    );
  }
  /**
   * Generate a form for passing data to a tool, converts a JSON object to a form object
   * @param action URL to pass data to
   * @param method Type of request for form
   * @param data Data to conver to form
   */
  generateForm(action, method, data) {
    console.log("create form");
    const form = document.createElement("form");
    form.style.display = "none";
    form.method = method;
    form.action = action;
    let input;
    console.log("se form values");
    Object.keys(data).forEach((key) => {
      const value = data[key];
      input = document.createElement("input");
      input.name = key;
      input.id = key;
      input.value = value;
      input.type = "hidden";
      form.appendChild(input);
    });
    const submitButton = document.createElement("input");
    submitButton.value = "Click";
    submitButton.type = "submit";
    form.appendChild(submitButton);
    console.log("append form");
    console.log(form);
    return form;
  }

  /**
   * Parse an XML configuration and convert it to setting for an LTI data item
   * @param xml
   */
  getConfiguration(xml): Observable<any> {
    const $this = this;
    const prom = new Observable((obs) => {
      try {
        const locations = [
          "editor_button",
          "course_navigation",
          "resource_selection",
        ];
        console.log(xml);

        const parseString = require("xml2js").parseString;
        parseString(xml, function (err, result) {
          const processed: any = { location: [] };
          if (result.cartridge_basiclti_link) {
            const settings = result.cartridge_basiclti_link;
            Object.keys(settings).forEach((k) => {
              if (k.match(/blti/)) {
                processed[k.replace(/blti:/, "")] = settings[k][0];
              }
            });
            if (processed["custom"]) {
              const customs = processed["custom"]["lticm:property"];
              if (customs) {
                processed.custom = customs.map((cust) => {
                  const c = {
                    custom_key: cust.$.name,
                    custom_value: cust._,
                  };

                  return c;
                });
              }
            }
            if (processed.extensions) {
              const add_props = processed.extensions["lticm:property"];
              console.log(add_props);
              if (add_props) {
                add_props.forEach((prop) => (processed[prop.$.name] = prop._));
              }
              const add_exts = processed.extensions["lticm:options"];
              console.log(add_exts);
              if (add_exts) {
                add_exts.forEach((ext) => {
                  if (locations.includes(ext.$.name)) {
                    const loc = { location_type: ext.$.name };
                    ext["lticm:property"].forEach(
                      (prop) => (loc[prop.$.name] = prop._)
                    );
                    processed.location.push(loc);
                  }
                });
              }
              delete processed.extensions;
            }
          }
          console.log(processed);
          $this.covertConfiguration.call($this, processed);
          console.log(processed);
          obs.next(processed);
        });
      } catch (e) {
        console.log(e);
        obs.next({ error: "There is an error in the XML" });
      }
    });
    return prom;
  }

  /**
   * Use the conversion rules to conver the LTI confuguration to one that will work with scaffold
   * @param object
   */
  private covertConfiguration(object) {
    console.log(this);
    const $this = this;
    Object.keys(object).forEach(function (k) {
      if (typeof object[k] === "string") {
        $this.conversionRules.forEach((rule) => {
          if (object[k].match(rule.match)) {
            console.log(rule.description);
            object[k] = object[k].replace(rule.target, rule.replace);
          }
        });
      } else if (object[k] && typeof object[k] === "object") {
        $this.covertConfiguration(object[k]);
      }
    });
  }
}
